import * as Vue from 'vue';
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSmoothScroll from 'vue3-smooth-scroll';
import DCommercialParams from "@components/organisms/DCommercialParams.vue";

$(window).on('load', function(e) {
  const mountEl = document.querySelector('#commercial-params');
  const app = Vue.createApp(DCommercialParams, {...mountEl.dataset});
  app.use(VueAxios, axios).use(VueSmoothScroll);
  app.mount('#commercial-params');
});

$('[data-switch-view]').on('click', function() {
  $(this).toggleClass('_list');
  $('[data-switch-button]').toggleClass('_active');
  $('[data-switch-content]').toggleClass('_list');
  $('[data-sorter-drop]').toggleClass('_hide');
});